import { readAdsConsent } from "../ads/consent";

const SESSION_COOKIE = "fh_analytics_session";

const readCookie = (name: string): string | null => {
  const prefix = `${name}=`;
  const match = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  return match ? decodeURIComponent(match.slice(prefix.length)) : null;
};

export const ensureAnalyticsSession = (): string | null => {
  if (typeof document === "undefined") return null;
  if (readAdsConsent() !== "accepted") return null;

  const existing = readCookie(SESSION_COOKIE);
  if (existing) return existing;

  const id = crypto.randomUUID();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${SESSION_COOKIE}=${encodeURIComponent(id)}; path=/; SameSite=Lax${secure}`;
  return id;
};

export const clearAnalyticsSession = (): void => {
  if (typeof document === "undefined") return;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${SESSION_COOKIE}=; path=/; max-age=0; SameSite=Lax${secure}`;
};
